module.exports = __webpack_public_path__ + "cd323af5e08917cd73979d63beb8c5aa.png";